import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { useNavigate, useParams } from 'react-router-dom';

// core components
import Navbar from "../layouts/Navbar.js";
import Footer from "../layouts/Footer.js";

import '../../assets/css/Board.css'

// reactstrap components
import {
  Label,
  Input,
} from "reactstrap";

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from "@fortawesome/free-solid-svg-icons";

export default function NoticeUpdate() {

  const navigate = useNavigate();
  const { param } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  
  const [formData, setFormData] = useState({
    writer: '관리자(Admin)',
    title: '',
    content: '',
    file: null,
    filename: '',
    published: 1,
  });

  useEffect(() => {
    //console.log(param);

    if(param !== undefined){
      // 서버에서 게시글 데이터 가져오는 로직
      async function selectNoticeById() {

        //console.log("param id : " + param);

        try {
          //로딩중 표기
          setIsLoading(true);

          const response = await axios.get(
            `/notice/selectNoticeById?id=${param}`,
            { baseURL : process.env.REACT_APP_SERVER_URL,
            },{
              withCredentials: true
            });

          const data = response.data;

          //console.log(data);

          //console.log("Posts Return : " + JSON.stringify(data.result));

          // console.log("Role Check Result : " + data.userRole);
          
          // 접근 사용자 권한 체크
          // if(data.userRole !== "") {
            // 데이터를 성공적으로 가져왔으므로 로딩 상태를 false로 변경
            setIsLoading(false);

            setFormData({
              id : data.result.id,
              writer : data.result.writer,
              title : data.result.title,
              content : data.result.content,
              filename : data.result.file_o_name,
              published : data.result.published
            })

          // } else {
          //   //로그인이 안된 상태인 경우, 로그인 페이지로 안내
          //   alert("해당 메뉴는 로그인 후에 사용 가능합니다. 로그인 페이지로 이동합니다.");

          //   navigate("/Login");
          // }

        } catch (error) {
          console.error('게시글 조회 오류:', error);
        }
      }
      
      selectNoticeById();
    } else {
      setIsLoading(false);
    }

  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;

    // 파일 입력인 경우 파일 객체 설정
    if (type === 'file') {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

const makeFormDataForServer = (e) => {
  const { writer, title, content, file, published } = formData;

    const formDataForServer = new FormData();
    formDataForServer.append('title', title);
    formDataForServer.append('content', content);
    formDataForServer.append('writer', writer);
    formDataForServer.append('published', published);
    formDataForServer.append('file', file);

    //console.log("formDataForServer : " + formDataForServer);

    return formDataForServer
}

const updateNotice = async (e) => {
    e.preventDefault();

    const formDataForServer = makeFormDataForServer();

    let registerRequest;

    try {
      registerRequest = await axios.post(
        `/notice/updateNotice?id=${param}`, formDataForServer,
        { baseURL : process.env.REACT_APP_SERVER_URL,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },{
          withCredentials: true
        });

        console.log('게시글 업데이트 성공');

        const { data: registerRequestData } = registerRequest;
        const messages = registerRequestData.messages;
        // 성공 메세지 표출
        if (messages && messages.success) {
          alert(messages.success);
          // 성공 후 페이지 이동
          return navigate("/Board");
        }

    } catch ({ error }) {
      //console.error('게시글 업로드 실패:', error);
      alert("게시글 등록에 실패하였습니다. 잠시 후에 다시 시도해주세요.")
    }
  };
  
  return (
    <>
    <Navbar/>
      <div className="wrapper">
        <div className="page-header">
          <div className="page-header-image" />

            <div id="Board" className="register-page">
            <div className="Section">
                <div className="cardWithTitle">
                <div className="SectionHeaderFull">
                    <div className="SectionHeaderTxtbox">
                    <div className="SectionHeaderCategory CategoryDark">Notice</div>
                    <div className="SectionHeaderTitle">공지사항</div>
                    <div className="SectionHeaderDescription">
                        외부 사용자에게 공개될 공지사항을 등록하는 화면입니다.
                    </div>
                    </div>
                </div>

                <div className="SectionContents" style={{marginTop:'30px'}}>
                    {isLoading &&
                          // 로딩 중일 때 로딩 스피너 또는 메시지 표시
                        <div className="loader">
                          <div className="loader-container">
                            <p className='loader-title'>Loading...</p>
                          </div>
                        </div>
                    }
                    <div className="form-control">
                    <form onSubmit={updateNotice}>
                        <div className="form-box">
                        <label htmlFor="writer">
                            <div className="form-label">작성자<b style={{color:'red'}}>&nbsp;*</b></div>
                            <input 
                            className="form-input"
                            type="text" 
                            id="writer" 
                            name="writer"
                            value={formData.writer}
                            required
                            onChange={ handleInputChange }
                            />
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="title">
                            <div className="form-label">제목<b style={{color:'red'}}>&nbsp;*</b></div>
                            <input 
                            className="form-input"
                            type="text" 
                            id="title" 
                            name="title" 
                            value={formData.title}
                            placeholder="게시글의 제목을 입력해주세요" 
                            required 
                            onChange={ handleInputChange }/>
                        </label>
                        </div>
                        <div className="form-box">
                        <label htmlFor="content">
                            <div className="form-label">내용</div>
                            <textarea 
                            className="form-input-area"
                            id="content"
                            name="content" 
                            value={formData.content}
                            placeholder="게시글의 내용을 입력해주세요" 
                            onChange={ handleInputChange }/>
                        </label>
                        </div>

                        <div className="form-box">
                            <label htmlFor="file">
                                <div className="form-label">첨부파일&nbsp;</div>
                                <div className="file-view">
                                {formData.filename &&
                                    <div className="form-result-file-box">
                                      <FontAwesomeIcon icon={faFile} style={{color:'lightgray'}}/> &nbsp;
                                      <span className="form-result-file">
                                        {formData.filename}
                                      </span> <br/>
                                    </div>
                                  }
                                <input 
                                className="form-input"
                                type="file" 
                                id="file" 
                                name="file" 
                                placeholder="첨부파일 등록"
                                onChange={ handleInputChange }/>
                                </div>
                            </label>
                        </div>

                        <div className="form-box">
                        <label htmlFor="published">
                            <div className="form-label">공개여부<b style={{color:'red'}}>&nbsp;*</b></div>
                            <div className="form-check-radio">
                              <Label className="form-check-label">
                                  <Input type="radio" name="published" id="Radios1" value="1" onClick={handleInputChange} defaultChecked/>
                                  공개
                                  <span className="form-check-sign"></span>
                              </Label>
                            </div>
                            <div className="form-check-radio">
                              <Label className="form-check-label">
                                <Input type="radio" name="published" id="Radios2" value="0" onClick={handleInputChange} />
                                비공개
                                <span className="form-check-sign"></span>
                              </Label>
                            </div>

                        </label>
                        </div>

                        <div className="form-button">
                            <div className="board-write-button-area">
                              <input type="button" className="itsBtnGray"  onClick={(e) => {e.preventDefault(navigate(-1))}} value="수정취소"/>
                              <input type="submit" value="수정"/><br/>
                            </div>
                        </div>
                    </form>
                    </div>
                </div>
                </div>

            </div>
            </div>
          
        </div>
      </div>
    <Footer />
    </>
  );
}